module.exports = __webpack_public_path__ + "img/zcsjk_icon_dia.f5e7e0e2.png";